import { GatewayId } from '@pillar-portal/database/dist/frontend';
import type { JsonObject } from '../../../common.types';
import type { CoreGatewayTransactionDetails } from '../../../payment.types';
import type { CardType } from '../../../samba-payment.types';
import type { LosslessNumber } from '../../../lossless-json-codec';

export interface ValorDelegateTokenResponse {
    client_token: string;
    validity: string;
    domain: string;
    epi: string;
}

export const ValorBrowserTokenizationSessionType = 'valor_browser_tokenization_session_v1' as const;

export interface ValorBrowserTokenizationSession extends ValorDelegateTokenResponse {
    readonly browser_tokenization_session_type?: typeof ValorBrowserTokenizationSessionType;
}

export interface ValorCardTokenizationResponse {
    error_no: 'S00';
    error_code: 'S00';
    cardToken: string;
    card_brand: string;
    card_type?: string;
    response: null;
}

export const ValorTokenizationResultType = {
    BROWSER_TOKENIZATION_V2: 'valor_browser_tokenization_v2',
} as const;

export interface ValorBrowserTokenizationResultV2 {
    readonly result_type: typeof ValorTokenizationResultType.BROWSER_TOKENIZATION_V2;
    readonly provider_request: JsonObject;
    readonly provider_response: JsonObject;
    readonly token: string;
    readonly card_brand: string;
    readonly card_type?: string;
}

export type ValorTokenizationResult =
    | ValorCardTokenizationResponse
    | ValorBrowserTokenizationResultV2;

export const ValorGatewayTransactionDetailsType = 'valor_gateway_transaction_details' as const;

export interface ValorGatewayTransactionCardMetadata {
    card_bin?: string;
    card_type?: CardType;
    issuing_bank?: string;
    country?: string;
    card_level?: string;
    card_category?: string;
}

export interface ValorGatewayTransactionTaxComponent {
    rate: LosslessNumber;
    amount: LosslessNumber;
    taxable_sales: LosslessNumber;
}

export interface ValorGatewayTransactionTaxDetails {
    state_tax?: ValorGatewayTransactionTaxComponent;
    city_tax?: ValorGatewayTransactionTaxComponent;
    reduced_tax?: ValorGatewayTransactionTaxComponent;
}

interface ValorGatewayTransactionDetailsBase extends CoreGatewayTransactionDetails {
    gateway_id: typeof GatewayId.VALOR_US;
    gateway_transaction_details_type: typeof ValorGatewayTransactionDetailsType;
    custom_fee_amount: LosslessNumber;
    card_scheme?: string;
    pan?: string;
    rrn?: string;
    stan_no?: string;
    batch_no?: string;
    auth_code?: string;
    cardholder_name?: string;
    card_metadata?: ValorGatewayTransactionCardMetadata;
    tax_details?: ValorGatewayTransactionTaxDetails;
}

export interface ValorGatewayTransactionDetailsV1 extends ValorGatewayTransactionDetailsBase {
    gateway_transaction_details_version: 1;
}

export interface ValorGatewayTransactionDetailsV2 extends ValorGatewayTransactionDetailsBase {
    gateway_transaction_details_version: 2;
    tip_amount: LosslessNumber;
}

export type ValorGatewayTransactionDetails =
    | ValorGatewayTransactionDetailsV1
    | ValorGatewayTransactionDetailsV2;
